'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Layout = require('./Layout');

var _Layout2 = _interopRequireDefault(_Layout);

var _Router = require('./Router');

var _Router2 = _interopRequireDefault(_Router);

var _DemoPage = require('./DemoPage');

var _DemoPage2 = _interopRequireDefault(_DemoPage);

var _globalStyles = require('./globalStyles');

var _globalStyles2 = _interopRequireDefault(_globalStyles);

_globalStyles2['default']();

function locationToHash(location) {
  return '/' + location.map(encodeURIComponent).join('/') + '/';
}

function locationToTitle(location) {
  return location.slice().reverse().join(' \\ ') + ' — Components Library';
}

exports['default'] = _createReactClass2['default']({

  propTypes: {
    demos: _propTypes2['default'].arrayOf(_propTypes2['default'].object.isRequired).isRequired
  },

  render: function render() {
    var demos = this.props.demos;

    var menu = demos.map(function (_ref) {
      var location = _ref.location;
      return { location: location, hash: locationToHash(location) };
    });
    var routes = demos.map(function (spec) {
      return {
        title: locationToTitle(spec.location),
        hash: locationToHash(spec.location),
        content: _react2['default'].createElement(
          _Layout2['default'],
          { menu: menu, fullWidth: spec.fullWidth },
          _react2['default'].createElement(_DemoPage2['default'], spec)
        )
      };
    }).concat([{
      title: 'Components Library',
      hash: '',
      content: _react2['default'].createElement(
        _Layout2['default'],
        { menu: menu },
        '← Use menu to start exploring the library'
      )
    }]);
    var notFoundRoute = {
      title: '404 — Components Library',
      content: _react2['default'].createElement(
        _Layout2['default'],
        { menu: menu },
        '404'
      )
    };
    return _react2['default'].createElement(_Router2['default'], { routes: routes, notFoundRoute: notFoundRoute });
  }

});
module.exports = exports['default'];